import { Heading, Paragraph } from '@hungryroot/ramen';
import { SectionList } from '../SectionList/SectionList';
import { privacySections } from './data';

import styles from './Privacy.module.css';

interface Props {
  testid?: string;
}

export function Privacy(props: Props) {
  const { testid } = props;
  return (
    <div className={styles.container} data-testid={testid}>
      <div className={styles.heading}>
        <Heading variant="H2" className={styles.title} testid="privacy-policy">
          Privacy Policy
        </Heading>
        <Paragraph testid="effective-date">
          Effective Date: October 3rd, 2024
        </Paragraph>
      </div>
      <div>
        <Paragraph className={styles['bottom-margin']}>
          This policy (this “Privacy Policy”) explains how Hungryroot, Inc.
          (“Hungryroot,” “we,” “us,” or “our”) processes personal information of
          customers or visitors (“you,” “your”) on{' '}
          <a
            href="https://www.hungryroot.com"
            target="_blank"
            className={styles.link}
          >
            www.hungryroot.com
          </a>{' '}
          (the “Site”), our mobile application (the “App”), or when you
          otherwise purchase or use our services, including by interacting with
          us via email, our call centers, our chatbot, and social media channels
          (collectively, the “Services”). If you do not agree to the terms of
          this Privacy Policy, do not use any of our Services or submit your
          personal information to us. Please read this Privacy Policy together
          with our Terms of Use and all other relevant privacy notices we may
          provide or post. This Privacy Policy does not apply to digital
          properties that do not link to this Privacy Policy or to third-party
          websites to which the Services may link.
        </Paragraph>
        <Paragraph
          className={`${styles['bottom-margin-large']} ${styles.italic}`}
        >
          Please review our U.S. State Privacy Law Notice available{' '}
          <a
            href="/privacy/state/"
            target="_blank"
            className={`${styles.link} ${styles.bold}`}
          >
            <span className={styles.link}>here</span>
          </a>{' '}
          for information related to residents of certain states, including
          California, Colorado and Virginia.
        </Paragraph>
      </div>
      <SectionList testid="privacy-list" data={privacySections} />
    </div>
  );
}
